'use client'

import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'

export function ProductImageSliderSkeleton(): React.ReactElement {
  return (
    <div className="flex h-auto w-full gap-4 sticky-desktop-element desktop:h-[35rem] desktop:max-w-[49.5rem]">
      <div className="relative hidden h-full w-10 justify-center desktop:flex">
        <BaseSkeleton className="size-10" />
      </div>

      <BaseSkeleton className="relative h-[16.875rem] min-w-0 flex-1 desktop:h-auto" />
    </div>
  )
}
